import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export function CustomerStep1Type({ formData, onChange, types }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">Select the type of business:</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {types.map((type) => {
          const Icon = type.icon;
          const isSelected = formData.customer_type === type.id;
          return (
            <div
              key={type.id}
              onClick={() => onChange('customer_type', type.id)}
              className={cn(
                'flex items-start gap-3 p-4 rounded-lg border text-left transition-all cursor-pointer',
                isSelected
                  ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-300 dark:border-blue-700'
                  : 'bg-white dark:bg-slate-700 border-slate-200 dark:border-slate-600 hover:border-blue-300 dark:hover:border-blue-600',
              )}
              data-testid={`customer-type-${type.id}`}
            >
              <div className={cn(
                'w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0',
                isSelected ? 'bg-blue-600 text-white' : 'bg-slate-100 dark:bg-slate-600 text-slate-500 dark:text-slate-400',
              )}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <p className={cn('font-medium', isSelected ? 'text-blue-700 dark:text-blue-400' : 'text-slate-700 dark:text-slate-300')}>{type.label}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400">{type.description}</p>
              </div>
            </div>
          );
        })}
      </div>

      {formData.customer_type === 'other' && (
        <div className="mt-4 space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">
            Specify Business Type <span className="text-red-500">*</span>
          </Label>
          <Input
            value={formData.custom_type}
            onChange={(e) => onChange('custom_type', e.target.value)}
            placeholder="Enter your business type..."
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
      )}
    </div>
  );
}
